"use client";
import React, { useState, useEffect } from "react";
import "../styles/globals.css";
import { Container, Row, Col, Card, Form, Button,InputGroup, Dropdown, Modal } from "react-bootstrap";
import sourceEndpointData from '../source_endpoints.json';
import targetEndpointData from '../target_endpoints.json';
import templateData from '../template.json';
import { useNavigate } from "react-router-dom";
export default function DataModels() {
  const [sourceEndpoints, setSourceEndpoints] = useState([]);
  const [selectedSourceEndpoints, setSelectedSourceEndpoints] = useState([]);
  const [targetEndpoints, setTargetEndpoints] = useState([]);
  const [selectedTargetEndpoints, setSelectedTargetEndpoints] = useState([]);
  const [showSchemaModal, setShowSchemaModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    // Assuming it's a local import, no fetch needed
    setSourceEndpoints(sourceEndpointData);
    setTargetEndpoints(targetEndpointData); 
  }, []);
  // const handleSelect = (endpointName) => {
  //   const selected = sourceEndpoints.find(ep => ep.name === endpointName);
  //   setSelectedEndpoint(selected);
  // };
  const showGeneratedSchema = () => {
    console.log("Current field_data:", formData.field_data); // Debugging
    if (formData.field_data.length > 0) {
      setShowSchemaModal(false); // Force a re-render
    setTimeout(() => setShowSchemaModal(true), 10);
    } else {
      alert("No schema data available!");
    }
  };
  
  // const handleSelectTarget = (endpointName) => {
  //   const selected = targetEndpoints.find(ep => ep.name === endpointName);
  //   setSelectedTargetEndpoint(selected);
  // };
 
  const handleSelectSource = (endpointName) => {
    const selected = sourceEndpoints.find(ep => ep.name === endpointName);
    if (selected && !selectedSourceEndpoints.some(ep => ep.name === selected.name)) {
      setSelectedSourceEndpoints([...selectedSourceEndpoints, selected]);
    }
  };

  const handleSelectTarget = (endpointName) => {
    const selected = targetEndpoints.find(ep => ep.name === endpointName);
    if (selected && !selectedTargetEndpoints.some(ep => ep.name === selected.name)) {
      setSelectedTargetEndpoints([...selectedTargetEndpoints, selected]);
    }
  };
  const generatedJson = {
    typeId: "number",
    groupId: "number",
    spec_Name: "string",
    categoryId: "number",
    position: "number",
    isFilter: "boolean",
    isRequired: "boolean",
    active: "boolean",
    defaultValue: "string",
  };

  const [formData, setFormData] = useState({
    endpoint_name: "",
    icon_name: "",
    webhoook_endpoint: false,
    url: "",
    path: "",
    field_data: [{ field: "", title: "", type: "", is_required: false }],
  });

 
  const generateSchema = async () => {
    setIsLoading(true);
   
    if (selectedSourceEndpoints.length === 0 || selectedTargetEndpoints.length === 0) {
      alert("Please select at least one source and target endpoint.");
      setIsLoading(false);
      return;
    }

    const payload = {
      source_endpoints: selectedSourceEndpoints.map(ep => ({
        name: ep.name,
        responseSchema: ep.responseSchema
      })),
      target_endpoints: selectedTargetEndpoints.map(ep => ({
        name: ep.name,
        requestSchema: ep.requestSchema
      })),
      template: templateData
    };
  
    console.log("Generated Payload:", JSON.stringify(payload, null, 2));
  
    try {      
      const response = await fetch("https://cqube.sstus.net/data_model_generator", {
        method: "POST",
        headers: { "Content-Type": "application/json" ,
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: JSON.stringify(payload)
      });
  
      const data = await response.json();
      console.log("API Response:", data);
      if (data.properties) {
        const fieldArray = [];
    // Recursive function to extract fields (handles nested properties)
    const extractFields = (obj, parentKey = "") => {
      Object.keys(obj).forEach((key) => {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const fieldType = Array.isArray(obj[key].type) ? obj[key].type[0] : obj[key].type;

        if (obj[key].type === "object" && obj[key].properties) {
          // If the key is an object, recursively extract its fields
          extractFields(obj[key].properties, fullKey);
        } else {
          // Otherwise, push it as a field
          fieldArray.push({
            field: fullKey, // Shows nested keys as "Parent.Child"
            title: fullKey.replace(/_/g, " ").toUpperCase(),
            type: fieldType,
            is_required: false,
          });
        }
      });
    };

    extractFields(data.properties);

    // Update form data state
    setFormData((prevState) => ({
      ...prevState,
      field_data: fieldArray
    })); 
    }
    } catch (error) {
      console.error("Error:", error);
      if (error.response && error.response.status === 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        setError("Session expired. Please login again.");
        navigate("/login", { state: { from: "/EcommerceBot" } });
      } else {
        setError(error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  

  // Handle field data changes
  const handleFieldDataChange = (index, event) => {
    const { name, value, type, checked } = event.target;
    const newFieldData = [...formData.field_data];

    // Handle checkbox toggle for is_required
    newFieldData[index][name] = type === "checkbox" ? checked : value;

    setFormData({ ...formData, field_data: newFieldData });
  };
 

  // Delete a field
  const deleteField = (index) => {
    const updatedFieldData = formData.field_data.filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      field_data: updatedFieldData,
    }));
  };


  return (
    <Container fluid className="bg-dark min-vh-100 d-flex justify-content-center align-items-center text-light">
      <Card className="p-4 bg-secondary text-light w-75 shadow-lg">
        <h1 className="text-info mb-4 text-center">New Data Model</h1>

        
        {/* Dropdowns and Endpoint Details */}
        <Row className="mb-4">
          <Col md={6}>
            <Dropdown onSelect={handleSelectSource} className="w-100">
              <Dropdown.Toggle variant="primary" className="w-100">
                Select Source Endpoints
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100">
                {sourceEndpoints.map((endpoint, index) => (
                  <Dropdown.Item key={index} eventKey={endpoint.name}>
                    {endpoint.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <ul>
              {selectedSourceEndpoints.map(ep => <li key={ep.name}>{ep.name}</li>)}
            </ul>
          </Col>

          <Col md={6}>
            <Dropdown onSelect={handleSelectTarget} className="w-100">
              <Dropdown.Toggle variant="primary" className="w-100">
                Select Target Endpoints
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100">
                {targetEndpoints.map((endpoint, index) => (
                  <Dropdown.Item key={index} eventKey={endpoint.name}>
                    {endpoint.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <ul>
              {selectedTargetEndpoints.map(ep => <li key={ep.name}>{ep.name}</li>)}
            </ul>
          </Col>
        </Row>
        {/* Additional Information Input */}
        <Form.Group className="mb-4">
          {/* <Form.Label>Provide any additional information</Form.Label> */}
          <InputGroup>
            {/* <Form.Control type="text" placeholder="Example: All target fields are mandatory" /> */}
            <Button variant="info" onClick={generateSchema} disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Generating...
                </>
              ) : (
                'Generate Schema'
              )}
            </Button>
          </InputGroup>
        </Form.Group>

        {/* Schema Fields */}
        <Card className="bg-dark border-warning p-4">
          <Row className="fw-bold text-warning">
            <Col>Field</Col>
            <Col>Title</Col>
            <Col>Type</Col>
            <Col>Required</Col>
            <Col>Action</Col>
          </Row>
          {formData.field_data.map((item, index) => (
            <Row key={index} className="align-items-center mt-3">
              <Col><Form.Control type="text" value={item.field} name="field" onChange={(e) => handleFieldDataChange(index, e)} /></Col>
              <Col><Form.Control type="text" value={item.title} name="title" onChange={(e) => handleFieldDataChange(index, e)} /></Col>
              <Col>
                <Form.Select name="type" value={item.type} onChange={(e) => handleFieldDataChange(index, e)}>
                  <option value="string">String</option>
                  <option value="number">Number</option>
                  <option value="boolean">Boolean</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Check type="checkbox" checked={item.is_required} name="is_required" onChange={(e) => handleFieldDataChange(index, e)} />
              </Col>
              <Col>
                <Button variant="danger" onClick={() => deleteField(index)}>Delete</Button>
              </Col>
            </Row>
          ))}
          {/* <Button className="mt-1" variant="info" onClick={addField}>+ Add Field</Button> */}
          <Button className="mt-1" variant="info" onClick={showGeneratedSchema}>Show Generated Schema</Button>
        </Card>
        {showSchemaModal && (
      <Modal show={showSchemaModal} onHide={() => setShowSchemaModal(false)}>
    <Modal.Header closeButton>
      <Modal.Title>Generated Schema Fields</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {formData.field_data.length === 0 ? (
        <p className="text-warning">No fields available</p>
      ) : (
        <Card>
          <Row className="fw-bold text-warning">
            <Col>Field</Col>
            <Col>Title</Col>
            <Col>Type</Col>
            {/* <Col>Required</Col> */}
          </Row>
          {formData.field_data.map((item, index) => (
            <Row key={index} className="align-items-center mt-3">
              <Col>{item.field}</Col>
              <Col>{item.title}</Col>
              <Col>{item.type}</Col>
              {/* <Col>{item.is_required ? "✅" : "❌"}</Col> */}
            </Row>
          ))}
        </Card>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowSchemaModal(false)}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)}

      </Card>
    </Container>
  );
};

  
